import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';

export default function TopBar({ onToggleSidebar }) {
  const { user, logout } = useAuth();
  const { mode, toggle } = useTheme();
  const navigate = useNavigate();

  const initials = user?.first_name
    ? user.first_name.charAt(0).toUpperCase()
    : user?.email?.charAt(0).toUpperCase() ?? '?';

  const displayName = user?.first_name
    ? `${user.first_name}${user.last_name ? ' ' + user.last_name : ''}`
    : user?.email;

  const isAdmin = user?.role === 'admin';
  const isGuest = !user;

  return (
    <header className="topbar">
      <button className="btn-sidebar-toggle" onClick={onToggleSidebar} aria-label="Menü öffnen">
        <i className="bi bi-list" />
      </button>

      <button
        className="btn-theme-toggle"
        onClick={toggle}
        aria-label={mode === 'dark' ? 'Hellmodus aktivieren' : 'Dunkelmodus aktivieren'}
        aria-pressed={mode === 'dark'}
        title={mode === 'dark' ? 'Hellmodus' : 'Dunkelmodus'}
      >
        <i className={`bi ${mode === 'dark' ? 'bi-sun' : 'bi-moon-stars'}`} />
      </button>

      {isGuest ? (
        <>
          <div className="user-badge">
            <div className="user-avatar"><i className="bi bi-person" /></div>
            <span className="role-tag">Gast</span>
          </div>
          <button className="btn-logout" onClick={() => navigate('/login')}>
            <i className="bi bi-box-arrow-in-right" />
            <span className="btn-logout-label">Anmelden</span>
          </button>
        </>
      ) : (
        <>
          <div className="user-badge">
            <div className="user-avatar">{initials}</div>
            <span className="user-name">{displayName}</span>
            <span className="role-tag">{user?.role}</span>
          </div>

          {isAdmin && (
            <a className="btn-logout btn-logout-desktop" href="/admin/users">
              <i className="bi bi-people" />
              <span className="btn-logout-label">Benutzerverwaltung</span>
            </a>
          )}

          <button className="btn-logout" onClick={logout}>
            <i className="bi bi-box-arrow-right" />
            <span className="btn-logout-label">Abmelden</span>
          </button>
        </>
      )}
    </header>
  );
}
